export { default as $ } from "jquery";
import moment from "moment";
export { moment };
window.moment = moment;
export { default as numeral } from "numeral";
export { default as ordinal } from "ordinal";
export { default as Pikaday } from "pikaday";
export { default as validator } from "validator";
